//
//
//

import { mapGetters } from 'vuex'

export default {
    name: 'PlaywireAdController',

    computed: {
        desiredUnits() {
            const units = [
                { type: 'bottom_rail' },
                { type: 'flex' },
            ]

            if (!this.showStreamPreview) {
                units.push({ type: 'corner_ad_video' })
            }

            return units
        },

        ...mapGetters(['showStreamPreview']),
    },

    methods: {
        /**
         * This is called by the router whenever the page is changed. It is not
         * called when the site is first loaded, or when the router detects the URL
         * changed but the page hasn't (i.e. when clicking on different groups).
         */
        pageChanged(to, from) { // eslint-disable-line no-unused-vars
            try {
                window.ramp.que.push(() => {
                    window.ramp.spaAds()
                })
            } catch (e) {
                console.error('Error while refreshing pw', e)
            }
        },

        setAdUnits(countPageView) {
            try {
                window.ramp.que.push(() => {
                    // https://support.playwire.com/docs/ads-api-methods#spaAds
                    window.ramp.spaAds({
                        ads: this.desiredUnits,
                        countPageView,
                    })
                })
            } catch (e) {
                console.error('Error while setting pw units', e)
            }
        },
    },

    mounted() {
        this.setAdUnits(true)
        this.$listenFor('pageChanged', this.pageChanged)
    },

    watch: {
        desiredUnits() {
            this.setAdUnits(false)
        },
    },
}
